export default class RequestPasswordReset {
  constructor(context) {
    this.context = context;
  }

  run(username) {
    this.context.gateways.authentication.requestPasswordReset(username);
  }
}
